import http from "./http.service";

/** Un corte del panel: una marca, o un tipo de repuesto. */
export interface ConteoDemanda {
    id: number | null;
    nombre: string;
    alertas: number;
    personas: number;
}

/** Una línea de demanda concreta, ya cruzada contra el catálogo publicado. */
export interface FilaDemanda {
    /** Los ids son la clave con la que se piden los contactos de la fila. `tipoId` null es "cualquier repuesto". */
    marcaId: number;
    modeloId: number;
    versionId: number | null;
    tipoId: number | null;
    marca: string;
    modelo: string;
    version: string;
    tipo: string;
    alertas: number;
    personas: number;
    publicaciones: number;
}

/** Una persona esperando una fila concreta. `celular` puede venir vacío: no todos lo cargaron. */
export interface ContactoDemanda {
    userId: number;
    nombre: string;
    celular?: string;
    alertas: number;
    desde?: string;
}

export interface PanelDemanda {
    resumen: {
        alertasActivas: number;
        personas: number;
        pedidosDistintos: number;
        pedidosSinCubrir: number;
        personasSinCubrir: number;
    };
    porMarca: ConteoDemanda[];
    porTipo: ConteoDemanda[];
    porMes: { periodo: string; alertas: number }[];
    demanda: FilaDemanda[];
}

/**
 * Qué está buscando la gente en el sitio.
 *
 * <p>Una sola llamada trae todo el panel. Los cortes son cinco (resumen, marcas, tipos, evolución y
 * el detalle) pero salen de las mismas dos consultas agregadas, así que pedirlos por separado
 * multiplicaría los viajes sin ahorrar trabajo del lado del server.
 */
class DemandaService {

    panel(meses = 12, topFilas = 50): Promise<PanelDemanda> {
        return http.get(`/api/demanda?meses=${meses}&topFilas=${topFilas}`);
    }

    /**
     * Quiénes están esperando una fila del panel, con su WhatsApp.
     *
     * <p>Va aparte y a pedido —al expandir la fila— y no dentro del panel: son cientos de filas y
     * traer los contactos de todas al entrar sería bajar la agenda entera de compradores para
     * mostrar cuatro gráficos.
     *
     * <p>`versionId`/`tipoId` en null se mandan omitidos, que es como el back los espera: `tipoId`
     * ausente significa el pedido de "cualquier repuesto", no "todos los tipos".
     */
    contactos(fila: Pick<FilaDemanda, "marcaId" | "modeloId" | "versionId" | "tipoId">): Promise<ContactoDemanda[]> {

        const params = new URLSearchParams();
        params.set("marcaId", String(fila.marcaId));
        params.set("modeloId", String(fila.modeloId));
        if (fila.versionId != null) params.set("versionId", String(fila.versionId));
        if (fila.tipoId != null) params.set("tipoId", String(fila.tipoId));

        return http.get(`/api/demanda/contactos?${params.toString()}`)
            .then((data: any) => data?.contactos || []);
    }
}

const demandaService = new DemandaService();
export default demandaService;
